// @flow

export const setDatalayerVar = (name: string, value: string) => {
    window.dataLayer.push({ [name]: value });
};

export const publishEvent = (eventName: string) => {
    window.dataLayer.push({ event: eventName });
};

export const customEvent = (event: { event: string, ...any }) => {
    window.dataLayer.push(event);
};
